module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Lisa Rogak\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Lisa Rogak is the author of "), _c('I', [_vm._v("In His Own Words: Colin Powell")]), _vm._v(" and "), _c('I', [_vm._v("Howard Dean In His Own Words")]), _vm._v(". Her works have been reviewed and otherwise mentioned in the "), _c('I', [_vm._v("Wall Street Journal")]), _vm._v(", "), _c('I', [_vm._v("USA Today")]), _vm._v(", "), _c('I', [_vm._v("Family Circle")]), _vm._v(", and hundreds of other publications. She lives in Lebanon, New Hampshire.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/s38BTW/tc-custom/9781907532719.jpg?1726519407702",
      "alt": "This image is the cover for the book Barack Obama"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Barack Obama\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_c('i', [_vm._v("New York Times")]), _vm._v(" Bestseller: A collection of quotations by the forty-fourth US president, arranged A-to-Z by topic.")]), _c('br'), _c('br'), _vm._v("From the day he delivered his keynote speech at the 2004 Democratic National Convention, Barack Obama became a national political figure—a little-known Illinois senator transformed into the country’s first African American president just four years later. He has been admired by millions for his calm demeanor, charisma, sense of humor, integrity, and exceptional eloquence."), _c('br'), _c('br'), _vm._v("Organized A-to-Z by topic, this book gathers his quotes on democracy, diversity, abortion, religion, AIDS, his critics, foreign policy, the Iraq war, the internet, terrorism, unemployment, gay marriage, and a host of other issues, as well as more personal subjects like his marriage, his childhood, his critics, and his cigarette habit. Informative and easy to read, this is a wide-ranging selection of commentary by one of the major figures of the twenty-first century world.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Aurum Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0